/**
 * Get script arguments.
 *
 * @internal
 */ export function getArgs() {
  // deno-lint-ignore no-explicit-any
  const { Deno, process } = globalThis;
  return Deno?.args ?? process?.argv.slice(2) ?? [];
}
//# sourceMappingURL=get_args.js.map